module.exports = __webpack_public_path__ + "img/m-start-back.183cb56d.jpg";